import { render, staticRenderFns } from "./WorkArea.vue?vue&type=template&id=7e3779c4&"
import script from "./WorkArea.vue?vue&type=script&lang=js&"
export * from "./WorkArea.vue?vue&type=script&lang=js&"
import style0 from "./WorkArea.vue?vue&type=style&index=0&id=7e3779c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports